<!-- ══════════════════════════════════════════════════════════════ -->
<!-- V1 / V2 Switching Tabs                                         -->
<!-- ══════════════════════════════════════════════════════════════ -->
<div class="col-sm-12 mb-3">
    <div class="version-toggle-wrapper justify-content-center">
        <div class="version-toggle">
            <a class="toggle-btn" [routerLink]="['../pmoDashboard']" routerLinkActive="active">
                PMO Dashboard (V1)
            </a>
            <a class="toggle-btn" [routerLink]="['../project-dashboard']" routerLinkActive="active">
                Project Dashboard (V2)
            </a>
        </div>
    </div>
</div>

<!-- ══════════════════════════════════════════════════════════════ -->
<!-- Project Selector (V2 Projects)                               -->
<!-- ══════════════════════════════════════════════════════════════ -->
<!-- <div class="col-sm-12 mb-2">
  <div class="card h-100">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-sm-3 mb-2 text-end">
          <label class="floating-label" style="font-weight: bolder;">Select Project Name</label>
        </div>
        <div class="col-sm-4 mb-2">
          <form [formGroup]="projectForm">
            <div class="input">
              <div class="input-item">
                <input list="projectListV2" (change)="fetchProjectDetails($event)" formControlName="project" />
                <datalist id="projectListV2">
                  <option [value]="item" *ngFor="let item of projectDropdownList"></option>
                </datalist>
                <label class="floating-label-special">Project Name*</label>
                <i class="ri-file-list-line"></i>
              </div>
            </div>
          </form>
        </div>
        <div class="col-sm-5 mb-2 d-flex align-items-center">
          <span class="v2-badge">V2 Projects</span>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- ══════════════════════════════════════════════════════════════ -->
<!-- Inner Nav-Tabs                                                -->
<!-- ══════════════════════════════════════════════════════════════ -->
<ul class="nav nav-tabs inner-tabs mb-3" role="tablist">
    <li class="nav-item" role="presentation">
        <a class="nav-link" [class.active]="activeInnerTab === 'hour-utilization'"
            (click)="activeInnerTab = 'hour-utilization'" href="javascript:void(0)" role="tab">
            <i class="ri-bar-chart-2-line"></i> Hour Utilization Summary
        </a>
    </li>
    <li class="nav-item" role="presentation">
        <a class="nav-link" [class.active]="activeInnerTab === 'project-summary'"
            (click)="activeInnerTab = 'project-summary'" href="javascript:void(0)" role="tab">
            <i class="ri-folders-line"></i> Project Summary
        </a>
    </li>
</ul>

<!-- ══════════════════════════════════════════════════════════════ -->
<!-- Tab: Hour Utilization Summary                                 -->
<!-- ══════════════════════════════════════════════════════════════ -->
<div *ngIf="activeInnerTab === 'hour-utilization'">

    <!-- Free Resources V2 -->
    <div class="col-sm-12 mb-2">
        <div class="card h-100">
            <div class="card-header">
                <h3 class="h5">Free Resources</h3>
            </div>
            <div class="card-body" style="overflow-y: scroll;">
                <div style="display: flex; justify-content: center; width: 100%;">
                    <div *ngIf="freeResourcesV2 && freeResourcesV2?.length > 0" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px 20px; text-align: center; width: 100%;">
                        <span *ngFor="let item of freeResourcesV2" style="font-weight: bold;">
                            {{item}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="row">
    <div class="col-sm-8 mb-2">
      <div class="card h-100">
        <div class="card-header">
          <h3 class="h5">Hours Estimation for complete project</h3>
        </div>
        <div class="card-body" style="padding: 2%;">
          <div style="text-align: center; margin-bottom: 12px;">
            <div style="margin-top: 8px; display: flex; justify-content: center; gap: 10px;">
              <div style="background-color: #FBC540; padding: 6px 12px; border-radius: 4px; font-weight: bold;">TOTAL HOURS</div>
              <div style="background-color: #E57B1E; padding: 6px 12px; border-radius: 4px; font-weight: bold;">Vs</div>
              <div style="background-color: #4A73C8; color: white; padding: 6px 12px; border-radius: 4px; font-weight: bold;">APPROVED HOURS</div>
            </div>
            <div style="margin-top: 8px; display: flex; justify-content: center; gap: 10px;">
              <div style="background-color: #FBC540; padding: 6px 12px; border-radius: 4px; font-weight: bold;">Yearly</div>
              <div style="background-color: #E57B1E; padding: 6px 12px; border-radius: 4px; font-weight: bold;">Vs</div>
              <div style="background-color: #4A73C8; color: white; padding: 6px 12px; border-radius: 4px; font-weight: bold;">Monthly</div>
            </div>
          </div>

          <div style="display: flex; justify-content: center; gap: 40px;">
            <ejs-accumulationchart [series]="[{
                dataSource: chartData1,
                dataLabel: dataLabel1,
                xName: 'x',
                yName: 'y',
                tooltipMappingName: 'z',
                innerRadius: '80%',
                palettes: ['#F7C542', '#4A73C8'],
                radius: '100%'
              }]" [legendSettings]="{ visible: true }"
              [tooltip]="{ enable: true, format: '${point.x}: ${point.y} Hrs<br/>Total: ${point.tooltip} Hrs' }"
              [annotations]="getChartAnnotation('Yearly')"
              [center]="{ x: '50%', y: '50%' }">
            </ejs-accumulationchart>

            <ejs-accumulationchart [series]="[{
                dataSource: chartData2,
                dataLabel: dataLabel2,
                xName: 'x',
                yName: 'y',
                tooltipMappingName: 'z',
                innerRadius: '80%',
                palettes: ['#F7C542', '#4A73C8'],
                radius: '100%'
              }]" [legendSettings]="{ visible: true }"
              [tooltip]="{ enable: true, format: '${point.x}: ${point.y} Hrs<br/>Total: ${point.tooltip} Hrs' }"
              [annotations]="getChartAnnotation('Monthly')"
              [center]="{ x: '50%', y: '50%' }">
            </ejs-accumulationchart>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-4 mb-2">
      <div class="card h-100">
        <div class="card-header">
          <h3 class="h5">Task Status</h3>
        </div>
        <div class="card-body" style="overflow-y: scroll;">
          <div style="text-align: center; margin-bottom: 12px;">
            <div style="margin-top: 8px; display: flex; justify-content: center; gap: 10px;">
              <div style="background-color: #FBC540; padding: 6px 12px; border-radius: 4px; font-weight: bold;">Open Task</div>
              <div style="background-color: #E57B1E; padding: 6px 12px; border-radius: 4px; font-weight: bold;">Vs</div>
              <div style="background-color: #4A73C8; color: white; padding: 6px 12px; border-radius: 4px; font-weight: bold;">Closed Task</div>
            </div>
          </div>
          <div style="display: flex; justify-content: center; gap: 40px;">
            <ejs-accumulationchart [series]="[{
                dataSource: chartData,
                dataLabel: dataLabel,
                xName: 'x',
                yName: 'y',
                innerRadius: '80%',
                palettes: ['#F7C542', '#4A73C8'],
                radius: '100%'
              }]" [legendSettings]="{ visible: true }"
              [tooltip]="{ enable: true, format: '${point.x}: ${point.y}' }"
              [center]="{ x: '50%', y: '50%' }">
              <ng-template #centerTemplate>
                <div [innerHTML]="centerText"></div>
              </ng-template>
            </ejs-accumulationchart>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-12 mb-2">
      <div class="card h-100">
        <div class="card-header">
          <h3 class="h5">Total Booked Hours</h3>
        </div>
        <div class="card-body">
          <div class="row pt-3">
            <form [formGroup]="bookedHoursForm">
              <div class="row m-0">
                <div class="col-sm-2 col-md-6 col-lg-3 col-xl-3" style="margin-right: 5px;">
                  <div class="input">
                    <div class="input-item" style="width: min-content;">
                      <input type="date" formControlName="startDate" />
                      <label class="floating-label-special">From</label>
                      <i class="ri-calendar-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-2 col-md-6 col-lg-3 col-xl-3" style="margin-left: 5px; margin-right: 5px;">
                  <div class="input">
                    <div class="input-item" style="width: min-content;">
                      <input type="date" formControlName="endDate" />
                      <label class="floating-label-special">To</label>
                      <i class="ri-calendar-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 text-end text-right" style="margin-left: 5px;">
                  <button type="button" class="btn" (click)="getTotalBookedHours()">
                    <div>Submit</div>
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="graph-container">
            <ejs-chart style='display:block;' [primaryXAxis]='primaryXAxis' [primaryYAxis]='primaryYAxis'
              [title]='title' [tooltip]="tooltip" (tooltipRender)="onTooltipRender($event)">
              <e-series-collection>
                <e-series [dataSource]='bookedHoursData' type='StackingColumn' xName='xName' yName='yName'></e-series>
              </e-series-collection>
            </ejs-chart>
            <div style="text-align: center; margin-top: 10px;">
              <strong>Project Approved Hrs Total = {{this.totalBookedHours}}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-8 mb-2">
      <div class="card h-100">
        <div class="card-header">
          <h3 class="h5">Project Efficiency</h3>
        </div>
        <div class="card-body">
          <div class="graph-container1">
            <ejs-chart style='display:block;' [primaryXAxis]='primaryXAxis1' [primaryYAxis]='primaryYAxis1'
              [title]='title1' [tooltip]="tooltip" (tooltipRender)="onTooltipRender($event)">
              <e-series-collection>
                <e-series [dataSource]='projectEfficiencyData' type='StackingColumn' xName='xName' yName='yName'></e-series>
              </e-series-collection>
            </ejs-chart>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-4 mb-2">
      <div class="card h-100">
        <div class="card-header">
          <h3 class="h5">Free Resources</h3>
        </div>
        <div class="card-body" style="overflow-y: scroll;">
          <div style="display: flex; justify-content: center; gap: 40px;">
            <div *ngIf="freeResources && freeResources?.length > 0">
              <span *ngFor="let item of freeResources" style="margin-left: 10px; font-weight: bold; margin-top: 10px;">
                {{item}} <br>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div> -->
</div>

<!-- ══════════════════════════════════════════════════════════════ -->
<!-- Tab: Project Summary                                          -->
<!-- ══════════════════════════════════════════════════════════════ -->
<div *ngIf="activeInnerTab === 'project-summary'">
    <div class="col-sm-12 mb-2">
        <div class="card h-100">
            <div class="card-header">
                <h3 class="h5">Under Development...</h3>
            </div>
        </div>
    </div>

    <!-- <div class="row">
    <div class="col-sm-6 mb-2">
      <div class="card h-100">
        <div class="card-header">
          <h5 class="card-title">Pie Chart</h5>
        </div>
        <div class="card-body d-flex justify-content-center align-items-center" style="min-height: 250px;">
          <div class="p-3">
            <ejs-accumulationchart>
              <e-accumulation-series-collection>
                <e-accumulation-series type='Pie' [dataSource]='designationData' xName='name' yName='value' [dataLabel]='datalabel'>
                </e-accumulation-series>
              </e-accumulation-series-collection>
            </ejs-accumulationchart>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-6 mb-2">
      <div class="card h-100">
        <div class="card-header">
          <h5 class="card-title">Risk Graph</h5>
        </div>
        <div class="card-body d-flex justify-content-center align-items-center" style="min-height: 250px;">
          <div class="col">
            <table class="table table-bordered table-responsive" id="rMatrix">
              <thead>
                <tr><th colspan="8">Probability</th></tr>
              </thead>
              <tbody>
                <tr lh="5">
                  <td rowspan="5" class="r-header">Severity</td>
                  <td></td>
                  <td class="M1">Very Probable</td>
                  <td class="M1">Probable</td>
                  <td class="M1">Perhaps</td>
                  <td class="M1">Improbable</td>
                </tr>
                <tr lh="4">
                  <td class="M1">Low</td>
                  <td class="M">{{riskManagement[0][0]}}</td>
                  <td class="M">{{riskManagement[0][1]}}</td>
                  <td class="L">{{riskManagement[0][2]}}</td>
                  <td class="L">{{riskManagement[0][3]}}</td>
                </tr>
                <tr lh="3">
                  <td class="M1">Moderate</td>
                  <td class="M">{{riskManagement[1][0]}}</td>
                  <td class="M">{{riskManagement[1][1]}}</td>
                  <td class="M">{{riskManagement[1][2]}}</td>
                  <td class="L">{{riskManagement[1][3]}}</td>
                </tr>
                <tr lh="2">
                  <td class="M1">High</td>
                  <td class="H">{{riskManagement[2][0]}}</td>
                  <td class="M">{{riskManagement[2][1]}}</td>
                  <td class="M">{{riskManagement[2][2]}}</td>
                  <td class="M">{{riskManagement[2][3]}}</td>
                </tr>
                <tr lh="1">
                  <td class="M1">Catastropic</td>
                  <td class="VH">{{riskManagement[3][0]}}</td>
                  <td class="H">{{riskManagement[3][1]}}</td>
                  <td class="M">{{riskManagement[3][2]}}</td>
                  <td class="M">{{riskManagement[3][3]}}</td>
                </tr>
              </tbody>
            </table>
            <br /><br />
            <table style="border: 1px solid #000;">
              <tr>
                <td style="text-align:center;padding:5px;"><b>Legend</b></td>
                <td style="width:100px;height:25px;text-align:center;padding:5px;font-size:smaller;" class="L">Acceptable</td>
                <td style="width:100px;height:25px;text-align:center;padding:5px;font-size:smaller;" class="M">Considerable</td>
                <td style="width:100px;height:25px;text-align:center;padding:5px;font-size:smaller;" class="H">Dangerous</td>
                <td style="width:100px;height:25px;text-align:center;padding:5px;font-size:smaller;" class="VH">Very Dangerous</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div> -->

    <!-- <div class="row">
    <div class="col-sm-6 mb-2">
      <div class="card h-100">
        <div class="card-header">
          <h5 class="card-title">Task Overdue in Project</h5>
        </div>
        <div class="card-body">
          <ag-grid-angular
            style="height: calc(100vh - 160px) !important;"
            class="ag-theme-material"
            (gridReady)="onGridReady($event)"
            [rowData]="rowData1"
            [columnDefs]="columnDefs1"
            pagination="true"
            [defaultColDef]="defaultColDef"
            paginationPageSize=10>
          </ag-grid-angular>
        </div>
      </div>
    </div>

    <div class="col-sm-6 mb-2">
      <div class="card h-100">
        <div class="card-header">
          <h5 class="card-title">Critical Risk in Project</h5>
        </div>
        <div class="card-body">
          <ag-grid-angular
            style="height: calc(100vh - 160px) !important;"
            class="ag-theme-material"
            (gridReady)="onGridReady($event)"
            [rowData]="rowData2"
            [columnDefs]="columnDefs2"
            pagination="true"
            [defaultColDef]="defaultColDef"
            paginationPageSize=10>
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div> -->

</div>